import HeaderContentsWithNoLink from '../../components/organism/headers/HeaderContentsWithNoLink.vue'
export default {
  components: { HeaderContentsWithNoLink }
}
